const initials = "product/";
export const SET_CATEGORIZED_PRODUCTS = `${initials}SET_CATEGORIZED_PRODUCTS`;
export const REMOVE_CATEGORIZED_PRODUCTS = `${initials}REMOVE_CATEGORIZED_PRODUCTS`;


